'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function GoogleAnalyticsTrackPageView({
  measurementId,
}: {
  measurementId: string;
}) {
  const pathname = usePathname();

  useEffect(() => {
    window.gtag?.('event', 'page_view', {
      page_path: pathname,
      page_location: window.location.href,
    });
  }, [measurementId, pathname]);

  return null;
}
